import angular from 'angular';

import templateUrl from './dotsCarouselComponent.html';

class DotsCarouselCtrl {
  constructor(
    Authentication,
    KeyboardService,
    Utils,
    $element,
    $transclude,
    $document,
    $parse,
    $scope
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      KeyboardService,
      Utils,
      $element,
      $transclude,
      $document,
      $parse,
      $scope,
    });
  }

  $onInit() {
    this.unregisterKeys = [
      this.KeyboardService.on(this.KeyboardService.KEYS.ARROW_LEFT, () => this.prev()),
      this.KeyboardService.on(this.KeyboardService.KEYS.ARROW_RIGHT, () => this.next()),
    ];
  }

  $onDestroy() {
    this.unregisterKeys.forEach((u) => u());
  }

  /**
   * Currently changing the number of slides after the component is rendered is not supported.
   * Adding that is possible but has a performace hit so we don't do it until we have to
   */
  $postLink() {
    this.transcludeContainerElement = this.$element.find('[dots-carousel-transclude]');
    this.$transclude((clone) => {
      this._slidesCount = Array.prototype.slice.call(clone).filter((c) => {
        const hideCondition = c.getAttribute?.('carousel-hide');
        const isHidden = hideCondition && this.$parse(hideCondition)(this.$scope);

        if (isHidden) {
          angular.element(c).addClass('ng-hide');
        }

        return c.tagName === 'DOTS-CAROUSEL-SLIDE' && !isHidden;
      }).length;

      this.transcludeContainerElement.append(clone);

      if (typeof this.slideIndex !== 'number') {
        this.slideIndex = typeof this.initialSlideIndex === 'number' ? this.initialSlideIndex : 0;
      }

      this.dots = new Array(this.slidesCount);
      this.rotate();
      this.transcludeContainerElement.addClass('with-transitions');
    });
  }

  get slidesCount() {
    return this._slidesCount;
  }

  set slidesCount(val) {
    // this field should not be mutable from the outside of this component
    // but a setter is required by angular inner mechanics
  }

  get slideIndex() {
    return this._slideIndex;
  }

  set slideIndex(value) {
    this._slideIndex = value;
    this.rotate();
  }

  rotate() {
    if (this.transcludeContainerElement) {
      this.transcludeContainerElement.css(
        this.Utils.getCssTransform(`translateX(${-this.slideIndex * 100}%)`)
      );
    }
  }

  next(canFinish) {
    if (this.slideIndex === this.slidesCount - 1) {
      if (canFinish) {
        return this.finish();
      }

      return;
    }

    this.slideIndex++;
  }

  prev() {
    if (this.slideIndex > 0) {
      this.slideIndex--;
    }
  }

  finish() {
    if (this.onFinish) {
      this.onFinish();
    }
  }
}

export default {
  transclude: true,
  templateUrl,
  bindings: {
    slideIndex: '=?',
    slidesCount: '=?',
    initialSlideIndex: '<?',
    onFinish: '&?',
    finishLabel: '@?',
  },
  controllerAs: 'ctrl',
  controller: DotsCarouselCtrl,
};
